module.exports = "/_next/static/images/e7b53bb15ebf14644eb628718ce448eb-roxinho-basicos-flutuantes-md@1x.png";